module.exports = __webpack_public_path__ + "static/media/zagaglia-fernando.a2e1ee84.jpg";